import { makeStyles } from '@material-ui/styles';

export default makeStyles(theme => ({
  root: {
    padding: '0px 24px',
    width: '100%',
    height: theme.settings.size.mobile.menuHeight,
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    boxShadow: '0px -8px 12px rgba(92, 131, 150, 0.08)',
    position: 'relative',
    zIndex: 100,
    '& .MuiTypography-subtitle1': { color: theme.palette.secondary.main },
  },
  icon: {
    marginBottom: 3,
    height: 25,
    display: 'flex',
    alignItems: 'center',
    fill: theme.palette.secondary.main,
  },
  activeMenuItem: {
    fill: theme.palette.colors.teal,
    fontWeight: 'bold',
    '&.MuiTypography-subtitle1': { color: theme.palette.colors.black },
  },
  menuPanel: {
    width: '80vw',
  },
  control: {
    width: '100%',
    display: 'flex',
    justifyContent: 'space-between',
    margin: [theme.spacing(2), 0],
  },
  link: {
    color: theme.palette.colors.teal,
  },
  menuItem: {
    '&:focus': {
      textDecoration: 'none',
    },
  },
}));



// WEBPACK FOOTER //
// ./src/layouts/AppLayout/components/Menu/components/MobileMenu/useStyles.js